<template>
	<div ref="el" class="db2-echart" :style="{ height: height }"></div>
</template>

<script>
import { echarts } from './chartTheme';

/**
 * Thin ECharts host: setOption on change, dispose on destroy, resize with the card.
 */
export default {
	name: 'HaqEChart',
	props: {
		/** ECharts option object */
		option: {
			type: Object,
			default: () => ({})
		},
		/** CSS height */
		height: {
			type: String,
			default: '100%'
		}
	},
	data() {
		return {
			chart: null,
			ro: null
		};
	},
	watch: {
		option: {
			deep: true,
			handler() {
				this.applyOption();
			}
		}
	},
	mounted() {
		this.chart = echarts.init(this.$refs.el, null, { renderer: 'canvas' });
		this.applyOption();
		this.chart.getZr().on('click', this.onZrClick);
		if (typeof ResizeObserver !== 'undefined') {
			this.ro = new ResizeObserver(() => {
				if (this.chart) this.chart.resize();
			});
			this.ro.observe(this.$refs.el);
		}
		window.addEventListener('resize', this.onWinResize);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.onWinResize);
		if (this.ro) this.ro.disconnect();
		if (this.chart) {
			this.chart.getZr().off('click', this.onZrClick);
			this.chart.dispose();
			this.chart = null;
		}
	},
	methods: {
		/**
		 * Push the current option into ECharts.
		 */
		applyOption() {
			if (!this.chart || !this.option) return;
			this.chart.setOption(this.option, true);
		},
		/**
		 * Forward a click anywhere on the canvas (not only a series hit).
		 */
		onZrClick() {
			this.$emit('chart-click');
		},
		/**
		 * Resize on window change.
		 */
		onWinResize() {
			if (this.chart) this.chart.resize();
		}
	}
};
</script>
